import {AfterViewInit, Directive, ElementRef} from '@angular/core';

@Directive({
    selector: '[readonly]' // Matches max-ninety-nine in template
})
export class ReadonlyDirective implements AfterViewInit {
    constructor(private el: ElementRef) {}

    ngAfterViewInit(): void {
        const inputElement = this.el.nativeElement.querySelector('input');
        if (inputElement) {
            inputElement.setAttribute('disabled', 'true');
        }
    }
}
